<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    

      
      
      
    </base-header>

    <!--Charts-->
 
    
    <div class="container-fluid mt--6">
      <div class="row">
         <div style="width:100%;margin:150px 0px;text-align:center;"><h2>Select The Company</h2></div>
     
		<div v-for="e in entities"  class="col-xl-2" @click="selectEntity(e.id, e.entity_name)" :key="e.id">
			<card  >
				<h4>{{e.entity_name}}</h4>
				{{e.uen}}
			</card>
		</div>


    	</div>
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'

  export default {
    components: {
  
    },
    data() {
      return {
     	 entities:[],
	
      };
    },
    methods: {
      selectEntity(eid, entity_name) {
			const client_info = JSON.parse(TokenService.getUserInfo());
			client_info.entity_id = eid;
			client_info.entity_name = entity_name;
			TokenService.saveUserInfo(JSON.stringify(client_info));
			
			this.$router.push( '/ec_dashboard')
      }
    },
    mounted() {
      
      	let uri = this.$base_url+'/api/v1/c/get_my_entities';
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.entities = response.data.entities;
   
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














